/**
 * Carousels grid snippet
 *
 * @class Snippet_CarouselsGrid
 * @extends Snippet
 */

Snippet_CarouselsGrid = (function(Snippet) {

	var Snippet_CarouselsGrid = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_CarouselsGrid.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config) {
			this.imagesLoaded = 0;
			this.carousels = [];
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			return $(this.config.el);
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
			console.log('[CAROUSELS GRID] render');

			var scope = this;
			var rowsInitHtml = '';
			// if ( ( !User.logged || !_.last( this.config.categories ).collection.length ) && _.last( this.config.categories ).id === 'progress' ) {
			// 	this.config.categories.pop();
			// }

			this.resetPosition();

			for (var i = this.config.categories.length; i--; ) {
				rowsInitHtml += '<div />'
			}
			$(this.config.el).append(rowsInitHtml);
			$(this.config.el).find('div').addClass(this.config.classToAdd);

			this.carousels = [];
			for ( var i = 0; i < this.config.categories.length; i++ ) {
				// max 1 item in row - for testing purposes:
				// scope.config.categories[i].collection.models = scope.config.categories[i].collection.models.slice(0, 1); 

				this.carousels.push(
					new this.config.snippet( this, {
						'el': scope.config.el + ' > div:eq(' + i + ')',
						'target': scope.config.el + ' > div:eq(' + i + ')',
						'collection': scope.config.categories.at(i).data,
						'assetsVisible': scope.config.assetsVisible,
						'assetsFocusableArray': scope.config.assetsFocusableArray,
						'neverEnding': scope.config.neverEnding,
						'randomly': scope.config.randomly,
						'maxItems': scope.config.maxItems,
						'title': scope.config.categories.at(i).getTitle()
					} )
				);
			}

			this.carousels.map( function( snippet, i ) {
				snippet.index = i;
				snippet.render();
				snippet.showArrows( false );
				snippet.on( 'focus:out', scope.onFocusOut, scope );
				snippet.on('imagesloaded', function() {
					++this.imagesLoaded;
					if (this.imagesLoaded === this.carousels.length) {
						this.trigger('imagesloaded');
					}
				}, this)
			}.bind(this) );

			if ( this.carousels.length ) {
				this.parent.showDownArrow();
			}

		},

		resetPosition: function() {
			delete this.focusedRow;
			this.clearTimeoutForSideArrows();

			this.carousels.map(function(snippet) {
				snippet.showArrows(false);
			});
		},

		clearTimeoutForSideArrows: function() {
			clearTimeout(this.timeoutForSideArrows);
			delete this.timeoutForSideArrows;
		},

		setTimeoutForSideArrows: function() {
			var scope = this;

			this.clearTimeoutForSideArrows();
			this.timeoutForSideArrows = setTimeout(function() {
				scope.getFocusedRow().showArrows(true);
			}, 100);
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function(index) {
			if (typeof index !== 'number') {
				index = this.getFocusedRow() ? this.getFocusedRow().index : 0;
			}

			this.getFocusedRow() ? this.getFocusedRow().showArrows(false) : void(0);
			this.setTimeoutForSideArrows();
			return this.carousels[index].focus();
		},

		onFocus: function($el) {
			this.$lastFocused = $el;
			if(this.getFocusedRow() && this.getFocusedRow().index > 0)
				this.parent.showUpArrow();
			this.parent.$lastFocused = $el;

			this.focusedRow = this.carousels[$el.parent().parent().parent().parent().index()];
		},

		/**
		 * @inheritdoc Snippet#onClick
		 * Call onEnter() on focused element
		 */
		onClick: function($el, e, stop) {
			// delegate click propagation into snippet's children
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		/**
		 * @inheritdoc Snippet#onScroll
		 */
		onScroll: function($el, delta, e, stop) {
			// delegate scroll propagation into snippet's children
			if(this.trigger('scroll', $el, delta, e, stop) === false) {
				return false;
			}
		},

		/**
		 * Manage the process of Focus delegation between snippets inside this snippet
		 *
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation
		 */
		onFocusOut: function( snippet, direction ) {
			if (direction === 'up') {
				if (snippet.index === 0) {
					// focus out (up)
					this.trigger('focus:out', this, direction);
				}
				else {
					// set last focused element for previous row to be able to keep focus in actual column
					this.hackLastFocusedRowItem(this.getFocusedRow().index -1, this.$lastFocused.index());
					// move to previous row snippet
					this.parent.move(-1, this.getFocusedRow().index)
						.bind(this)
						.then(function() {this.onUp()});
				}
			}
			else if (direction === 'down') {
				if (snippet.index < this.config.categories.length - 1) {
					// set last focused element for next row to be able to keep focus in actual column
					this.hackLastFocusedRowItem(this.getFocusedRow().index + 1, this.$lastFocused.index());
					// move to next row snippet					
					this.parent.move(1, this.getFocusedRow().index)
						.bind(this)
						.then(function() {this.onDown()});				
				}
				else {
					this.trigger('focus:out', this, direction);
				}
			}
		},

		/**
		 * Set last focused element for one of grid's row to be able to keep focus in actual column
		 * @param snippetIndex {number}
		 * @param itemIndex {number}
		 */
		hackLastFocusedRowItem: function(snippetIndex, itemIndex) {
			var snippet = this.carousels[snippetIndex];
			var $li = snippet.$el.find('li');
			var $el = $li.eq(itemIndex);

			if (!$el.hasClass('focusable')) {
				$el = $li.filter('.focusable').eq(-1);
			}

			snippet.$lastFocused = $el;
		},

		onUp: function() {
			return false;
		},

		onDown: function() {
			return false;
		},

		getFocusedRow: function() {
			return this.focusedRow;
		},

		/**
		 * Test focusable
		 */
		isFocusable: function() {
			return !!this.getFocusable().length;
		},

		clear: function() {}

	});

	return Snippet_CarouselsGrid;

})(Snippet);




//////////////////
// WEBPACK FOOTER
// ./js/snippet/carousels_grid.js
// module id = 61
// module chunks = 0